export default __webpack_public_path__ + "static/N0187-c9ea5412345ad65d22d1ddefd6e02f44.png";